<template>
  <div>
    <div v-if="loading">
      <v-skeleton-loader type="image" height="56" class="mb-6"></v-skeleton-loader>
      <v-skeleton-loader type="image" height="56" class="mb-6"></v-skeleton-loader>
    </div>
    <div v-else>
      <div v-for="(number, index) in items" :key="index" class="d-flex align-top">
        <v-text-field
          v-model="items[index][itemKey]"
          :rules="rules"
          label="PSPS Number*"
          color="brandPrimary"
          type="text"
          outlined
        ></v-text-field>
        <v-btn v-if="canDelete(items[index])" icon @click="deleteNumber(index)" class="mt-2 ml-2">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
      <Button text color="brandPrimary" @click="addNumber" class="mb-4">
        <v-icon left>mdi-plus</v-icon> ADD
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/generic/Button.vue";

export default {
  name: "DynamicInputList",
  components: {
    Button,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemKey: {
      type: String,
      default: "id",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Function,
      default: () => true,
    },
  },
  methods: {
    addNumber() {
      this.$emit("add");
    },
    deleteNumber(index) {
      this.$emit("delete", index);
    },
  },
};
</script>

<style scoped></style>
